module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-header'), _vm._v(" "), _c('v-banner'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('produce-service'), _vm._v(" "), _c('local-service'), _vm._v(" "), _c('big-data-show'), _vm._v(" "), _c('cooperative-partner'), _vm._v(" "), _c('contactus')], 1), _vm._v(" "), _c('v-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9e6f3850","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 142
// module chunks = 1